module.exports = __webpack_public_path__ + "static/media/dont1.0707a796.png";